import { Component, Input, OnInit } from '@angular/core';
import { IBrandResources } from 'src/app/domain/interfaces/brand/interface-brand-resources';

@Component({
  selector: 'app-footer-secondary-brand',
  templateUrl: './footer-secondary-brand.component.html',
  styleUrls: ['./footer-secondary-brand.component.scss']
})
export class FooterSecondaryBrandComponent implements OnInit {
  @Input() brandResources!: IBrandResources;
  constructor() { }

  ngOnInit(): void {
  }

}
